import React, { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import { useSelector } from "react-redux";
import { client_name } from "../../../Helpers/request";
import BannerSlider from "./Components/Bannerslider";
import ShopByDiamondShape from "./Components/ShopByDiamondShape";
import ExploreCollection from "./Components/ExploreCollection";
import DesignDiamondRing from "./Components/DesignDiamondRing";
import ShopRingByStyle from "./Components/ShopRingByStyle";
import GemstoneGlamour from "./Components/GemstoneGlamour";
import CustomDesign from "./Components/CustomDesign";
import ConsultSpecialist from "./Components/ConsultSpecialist";
import Reviews from "./Components/Reviews";
// import Customer from "./Components/Customer";
import Insta from "./Components/insta";
import SignupTo from "./Components/SignupTo";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AdvantageMont from "./Components/AdvantageMont";
import RingType from "./Components/RingType";

const Home = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const history = useHistory();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      // disable: 'mobile'
    });
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails?.description}></meta>
        <meta name="keywords" content={metaDetails?.keywords}></meta>
        {/*Og Tags */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={metaDetails?.title} />
        <meta property="og:description" content={metaDetails?.description} />
        <meta property="og:url" content={metaDetails?.url} />
        <meta property="og:site_name" content={client_name?.c_name} />
      </Helmet>

      <div className="LandingPageShocase">

        <BannerSlider />
        <ShopByDiamondShape />
        <ExploreCollection />
        <DesignDiamondRing />
        <ShopRingByStyle />
        <RingType />
        {/* <GemstoneGlamour /> */}
        <CustomDesign />
        <ConsultSpecialist />
        <Reviews />
        {/* <Customer /> */}
        <AdvantageMont />
        {/* <Insta /> */}
        <SignupTo />
      </div>
    </>
  );
};

export default Home;
